// extracted by mini-css-extract-plugin
export default {"wrapper":"MEl3n0x9vexGW_mS4qZ7","input":"OtO03YMVxnxOrB0mXJoq","label":"Mjkhxl2DJcA_e9VQg_jA"};